// ################################### Variable Resolver ###################################
export const smartDocParamResolver_PrettyPrint = 'pretty-print';
export const smartDocParamResolver_Name = 'name';
export const smartDocParamResolver_Value = 'value';
export const smartDocParamResolver_Variable_Time = 'time';
export const smartDocParamResolver_Unit = 'unit';
export const smartDocParamResolver_VariableResolver = [
    smartDocParamResolver_PrettyPrint,
    smartDocParamResolver_Name,
    smartDocParamResolver_Value,
    smartDocParamResolver_Variable_Time,
    smartDocParamResolver_Unit
];
// ################################### Template Resolver ###################################
export const smartDocParamResolver_LatestSmartDoc = 'latest-smart-doc';
export const smartDocParamResolver_FirstSmartDoc = 'first-smart-doc';
export const smartDocParamResolver_New = 'new-smart-doc';
export const smartDocParmaResolver_TemplateResolver = [smartDocParamResolver_FirstSmartDoc,
    smartDocParamResolver_LatestSmartDoc,
    smartDocParamResolver_New];
// ################################### Navigation Response Resolver ###################################
export const smartDocParamResolver_ShortName = 'short-protocol-name';
export const smartDocParamResolver_FullName = 'full-protocol-name';
export const smartDocParamResolver_NextStep = 'next-step';
export const smartDocParamResolver_TransitionLabel = 'transition-label';
export const smartDocParamResolver_ResolutionInfo = 'resolution-info';
export const smartDocParamResolver_NavigationResponse = [
    smartDocParamResolver_ShortName,
    smartDocParamResolver_FullName,
    smartDocParamResolver_NextStep,
    smartDocParamResolver_TransitionLabel,
    smartDocParamResolver_ResolutionInfo,
];
// ################################### Navigation Response Resolver ###################################
export const smartDocParamResolver_WorkingDiagnosis_Name = 'protocol-name';
export const smartDocParamResolver_WorkingDiagnosis = [smartDocParamResolver_WorkingDiagnosis_Name];
// ################################### Order Resolver ###################################
export const smartDocParamResolver_Order_OrderName = 'order-name';
export const smartDocParamResolver_Order_OrderType = 'order-type';
export const smartDocParamResolver_Order_Subtype = 'sub-type';
export const smartDocParamResolver_Order = [
    smartDocParamResolver_Order_OrderName,
    smartDocParamResolver_Order_OrderType,
    smartDocParamResolver_Order_Subtype,
];
// ################################### Physician Notes Resolver ###################################
export const smartDocParamResolver_PhysicianNotes_DateTimeContent = 'date-time-content';
export const smartDocParamResolver_PhysicianNotes = [smartDocParamResolver_PhysicianNotes_DateTimeContent];
// ################################### Orders Resolver ###################################
export const smartDocParamResolver_Orders_DateTimeName = 'date-time-name';
export const smartDocParamResolver_Orders = [smartDocParamResolver_Orders_DateTimeName];
// ################################### MDM Resolver ###################################
export const smartDocParamResolver_MDM_NamesOfProtocols = 'names-of-protocols';
export const smartDocParamResolver_MDM_ProtocolsNavigationSteps = 'protocols-navigation-steps';
export const smartDocParamResolver_MDMs = [
    smartDocParamResolver_MDM_NamesOfProtocols,
    smartDocParamResolver_MDM_ProtocolsNavigationSteps
];
// ################################### Time Resolver ###################################
export const SmartDocParamResolver_Time_CurrentTime = 'current-time';
export const smartDocParamResolver_Time = [SmartDocParamResolver_Time_CurrentTime];
//# sourceMappingURL=types.js.map